/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------*/

function getSiteId() {
  var userSiteInfo = localStorage.getItem('userSiteInfo');
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].siteId;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).siteId;
  }
  else
    return 0;
}

function getItems(){
  var items = [{
      url: '/principal/dashboard',
      name: "Dashboard",
      slug: "Dashboard",
      icon: "BookIcon",
      i18n: "Dashboard",
    },  
  ];
  return items;
}

export default getItems();